const myAccountBase = '/my-account';

export const myAccountLinks = {
  login: `${myAccountBase}/login`,
  dashboard: myAccountBase,
  myPets: `${myAccountBase}/my-pets`,
  myPetsPolicy: `${myAccountBase}/my-pets/policy`,
  myDetails: `${myAccountBase}/my-details`,
  referAFriend: `${myAccountBase}/refer-a-friend`,
  inclusiveBenefits: `${myAccountBase}/inclusive-benefits`,
  freeCover: `${myAccountBase}/free-cover`,
  helpAndContact: `${myAccountBase}/help-and-contact`,
  rewardStatement: `${myAccountBase}/reward-statement`,
  marketingMaterials: `${myAccountBase}/marketing-materials`,
  amendAPolicy: `${myAccountBase}/amend-a-policy`,
  referAFriendTerms: `${myAccountBase}/refer-a-friend-terms`,
  addALitter: `${myAccountBase}/add-litter`,
  claims: `${myAccountBase}/claims`,
  myRewards: `${myAccountBase}/your-rewards`,
  myClaims: `${myAccountBase}/my-claims`,
  vetGuide: `${myAccountBase}/agria-app`,
  documentHub: `${myAccountBase}/document-hub`,
  documentHubPolicyDocuments: `${myAccountBase}/document-hub/policy-documents`,
  documentHubClaims: `${myAccountBase}/document-hub/claims`,
  breederClubEssentials: `${myAccountBase}/breeder-club-essentials`,
} as const;
